import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

export const User = ({ size = 44, className, color }: SvgProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      color={color}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4424_102122)">
        <path
          d="M8.00065 9.66732C10.3018 9.66732 12.1673 7.80184 12.1673 5.50065C12.1673 3.19946 10.3018 1.33398 8.00065 1.33398C5.69946 1.33398 3.83398 3.19946 3.83398 5.50065C3.83398 7.80184 5.69946 9.66732 8.00065 9.66732ZM8.00065 9.66732C4.31875 9.66732 1.33398 11.9059 1.33398 14.6673M8.00065 9.66732C11.6826 9.66732 14.6673 11.9059 14.6673 14.6673"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_4424_102122">
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);
